import { Typography, Box, Grid } from "@mui/material";
import StandardButton from "../../../../components/StandardButton";
import { useRecoilValue } from "recoil";
import React from "react";
import organizationIdSelector from "../../../../atoms/organizationIdSelector";
import useSharedFiles from "../../../../hooks/useSharedFiles";
import { consola } from "consola";

import MightyDataGrid from "../../../../components/organisms/MightyDataGrid";
import FileEditDialog from "./FileEditDialog";
import useEvents from "../../../../hooks/useEvents";
import EmptyFiles from "./EmptyFiles";

const EditFiles = () => {
  const events = useEvents();

  const organizationId = useRecoilValue(organizationIdSelector);
  const { sharedFiles, sharedFilesLoading, uploadOrganizationFile, deleteFile, updateFile } =
    useSharedFiles({
      uid: localStorage.getItem("uid"),
      clientUID: undefined,
      organizationId,
      global: true,
    });

  const [selectedFile, setSelectedFile] = React.useState(null);
  const [dialogOpen, setDialogOpen] = React.useState(false);

  const onEdit = (row) => {
    consola.log(row);
    setSelectedFile(row);
    setDialogOpen(true);
    consola.log(row);
    events.logButtonClick({
      buttonName: "Edit File",
      pageName: "Library",
      tabName: "Files",
    });
  };

  const onDelete = (row) => {
    deleteFile({ id: row.id });
    events.logButtonClick({
      buttonName: "Delete File",
      pageName: "Library",
      tabName: "Files",
    });
  };

  const columns = React.useMemo(() => {
    return [
      {
        field: "name",
        headerName: "File Name",
        minWidth: 100,
        flex: 1,
        hideable: false,
        headerAlign: "left",
        align: "left",
      },
    ];
  }, []);

  // Show loading first, then empty state when data confirms no files
  if (sharedFilesLoading) {
    return <Typography>Loading files...</Typography>;
  }

  if (!sharedFiles || sharedFiles.length === 0) {
    return (
      <EmptyFiles
        onUploadFile={(files) => {
          if (files && files[0]) {
            uploadOrganizationFile({ file: files[0] });
          }
        }}
      />
    );
  }

  return (
    <>
      <Grid container style={{ marginTop: 0 }}>
        <Grid item xs={8}>
          <Typography variant="h6">Organization Files</Typography>
          <Typography
            style={{ fontSize: 16, fontWeight: "normal", marginBottom: 12 }}
          >
            These are your organizations shared files. These files will be
            available to all clients in your organization.
          </Typography>
        </Grid>

        <Grid item xs={4}>
          <Box display="flex" flexDirection="row" justifyContent={"flex-end"}>
            <StandardButton component="label" variant="primary">
              Upload a File
              <input
                hidden={true}
                type="file"
                accept=".pdf,.csv,.doc,.docx,.txt,.xls,.xlsx,.zip,.rtf,.rar,.ppt,.pptx,.mp4,.mp3,.png,.jpg,.jpeg"
                onChange={(e) => {
                  uploadOrganizationFile({ file: e.target.files[0] });
                  events.logButtonClick({
                    buttonName: "Upload File",
                    pageName: "Library",
                    tabName: "Files",
                  });
                }}
              />
            </StandardButton>
          </Box>
        </Grid>
      </Grid>

      <MightyDataGrid
        entityName="files"
        columns={columns}
        rows={sharedFiles}
        showActions={true}
        actionConfig={{
          onEdit: onEdit,
          onDelete: onDelete,
          entityName: "File",
          pageName: "Library",
          tabName: "Files",
          customDeleteMessage:
            "This will permanently delete this file and clients will not be able to view it anymore.",
        }}
      />

      {dialogOpen && (
        <FileEditDialog
          open={dialogOpen}
          file={selectedFile}
          onDialogClosed={(changes, file) => {
            setDialogOpen(false);
            setSelectedFile(null);
            consola.log(changes);
            consola.log(file);

            if (changes) {
              updateFile({
                id: file.id,
                name: changes.name,
                description: changes.description,
              });
            }
          }}
        />
      )}
    </>
  );
};

export default EditFiles;
